angular.module('app').filter('apPatientPortalThumbnailSrc', [function () {
    'use strict';
    return function (patientId, height, width) {
        if(!patientId) {
            // if the patientId is null or undefined, return undefined because a valid url can't be formed
            // and undefined can be handled accordingly
            return;
        }

        if(height && !width) {
            width = height;
        }

        var url = 'person/' + patientId + '/thumbnail';

        if(height) {
            url += '?height=' + height + '&width=' + width;
        }

        return url;
    };
}]);
